import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { useState } from "react";
const PrivateRoute = () => {
           const [token] = useState(Cookies.get("userToken"));
    

  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
